import { render, staticRenderFns } from "./ViewAlertrecordDetail.vue?vue&type=template&id=c2cc5a66&scoped=true&"
import script from "./ViewAlertrecordDetail.vue?vue&type=script&lang=js&"
export * from "./ViewAlertrecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./ViewAlertrecordDetail.vue?vue&type=style&index=0&id=c2cc5a66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cc5a66",
  null
  
)

export default component.exports